import axios from "axios";
import jwt_decode from "jwt-decode";
import localforage from "localforage";
export function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

const api = axios.create({
    baseURL: process.env.REACT_APP_LAYER_API_BASEURL,
});
export const dataAPI = axios.create({
    baseURL: process.env.REACT_APP_LAYER_API_BASEURL,
});
export const siteAPI = axios.create({
    baseURL: process.env.REACT_APP_SITE_API_BASEURL,
});
export const configAPI = axios.create({
    baseURL: process.env.REACT_APP_CONFIG_BASEURL,
});

export const authServer = axios.create({
    baseURL: process.env.REACT_APP_AUTH_SERVER_BASEURL,
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    },
});

siteAPI.interceptors.request.use(
    function (config) {
        //add auth header
        let token = getCookie("ast");
        config.headers.Authorization = `Bearer ${token}`;
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

dataAPI.interceptors.request.use(
    function (config) {
        let urlParts = config.url.split("/");

        let token = getCookie("ast");

        let cachekey = "00000000-0000-0000-0000-000000000000"; // GUEST UserID
        if (token) {
            let dt = jwt_decode(token);
            cachekey = dt.sub;
        }

        if (config.method.toLocaleLowerCase() === "get") {
            config.validateStatus = (status) => {
                return (status >= 200 && status < 300) || status === 304;
            };
            //if request is to the layers data endpoints
            if (
                urlParts.length === 3 &&
                urlParts[0].toLowerCase() === "layers" &&
                urlParts[2].toLowerCase() === "data"
            ) {
                if (config.params) {
                    //Add key parameter to query string this is used to prevent the browser/public caches from returning data for the wrong user/role
                    config.params.key = cachekey;
                }
                //Get a last modified date from local storage
                let lmd = localStorage.getItem(
                    `${cachekey}_${urlParts[1]}_${config.params?.PageNumber}_${config.params?.PageSize}`
                );
                //check to see if we have a last modified date stored and we have not already set the header elsewhere.
                //To bypass the cache the "If-Modified-Since" should be set in the original get request.
                if (lmd && !config.headers["If-Modified-Since"]) {
                    config.headers["If-Modified-Since"] = lmd;
                }
            }
        }
        //add auth header
        config.headers.Authorization = `Bearer ${token}`;

        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

dataAPI.interceptors.response.use(
    (response) => {
        let urlParts = response.config.url.split("/");
        if (response.headers["last-modified"]) {
            //Store information about the layer last modified date
            localStorage.setItem(
                `${response.config.params?.key}_${urlParts[1]}_${response.config.params?.PageNumber}_${response.config.params?.PageSize}`,
                `${response.headers["last-modified"]}`
            );
            //check to see if we accessed the Layer Data endpoints
            if (
                response.status === 200 &&
                urlParts.length === 3 &&
                urlParts[0].toLowerCase() === "layers" &&
                urlParts[2].toLowerCase() === "data"
            ) {
                //Caching Key format {user sid}_{layerid}_{pageNumber}_{pagesize}
                localforage
                    .setItem(
                        `${response.config.params?.key}_${urlParts[1]}_${response.config.params?.PageNumber}_${response.config.params?.PageSize}`,
                        response.data
                    )
                    .catch(function (err) {
                        // This code runs if there were any errors
                        //console.log(err);
                        //IF an error happened gettign it from the cache clear the last modified date to repull the server in the next request.
                        localStorage.removeItem(
                            `${response.config.params?.key}_${urlParts[1]}_${response.config.params?.PageNumber}_${response.config.params?.PageSize}`
                        );
                    });
            }
        }

        return response;
    },
    (error) => {
        return Promise.reject(error);
    }
);

authServer.interceptors.request.use(
    function (config) {
        // Do something before request is sent
        if (
            config.url === "protocol/openid-connect/token" &&
            config.data.grant_type === "password"
        ) {
        } else if (
            config.url === "protocol/openid-connect/token" &&
            config.data.grant_type === "refresh_token"
        ) {
            config.data.refresh_token = getCookie("rft");
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

authServer.interceptors.response.use(
    (response) => {
        var now = new Date();
        const refreshToken = response.data.refresh_token;
        var tokendata = jwt_decode(refreshToken);
        now.setTime(tokendata.exp * 1000); //convert time from seconds to milliseconds
        if (refreshToken) {
            document.cookie = `rft=${refreshToken}; sameSite=strict ; expires=${now.toUTCString()}`;
        }
        const access_token = response.data.access_token;
        tokendata = jwt_decode(access_token);
        now.setTime(tokendata.exp * 1000); //convert time from seconds to milliseconds
        if (access_token) {
            document.cookie = `ast=${access_token}; sameSite=strict; expires=${now.toUTCString()}`;
        }
        return response;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;
